import React from 'react';
interface IconProps {
    width?: number;
    height?: number;
}

const StripeIcon = (props: IconProps) => {
    return (
        <svg viewBox="0 0 13 4" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect x={0.137} y={0.273} width={12} height={3} rx={1.5} fill="#fff" />
        </svg>
    );
};

export default StripeIcon;
